export function formatProjectPosition(
  indices: number[],
  isAlternative?: boolean | null
) {
  let result = ""

  if (indices.length === 1) {
    result = `${indices[0] + 1}.0`
  } else {
    result = indices.map((i: number) => i + 1).join(".")
  }
  if (isAlternative) {
    result = `${result} (a)`
  }

  return result
}
